import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShipmentProductDimUomList } from '../common/CommonActions';
import { getProductDimUomListEffect } from '../shipment/ShipmentEffects';

const useShipmentProductDimUomList = () => {
  const [list, setList] = useState();
  const { shipmentProductDimUomList } = useSelector((state) => state.common);
  const dispatch = useDispatch();

  useEffect(() => {
    if (shipmentProductDimUomList.success) {
      setList(shipmentProductDimUomList.data);
    } else {
      getList();
    }
  }, [shipmentProductDimUomList]);

  const getList = async () => {
    try {
      dispatch(setShipmentProductDimUomList({ success: true, data: [] }));
      const { data } = await getProductDimUomListEffect();
      setList(data);
      dispatch(setShipmentProductDimUomList({ success: true, data }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useShipmentProductDimUomList;
